import { useEffect, useRef } from "react";
import { AccordionProps } from "./AccordionButton";

export const AccordionPane = (props: AccordionProps): JSX.Element => {
  const { paneContent, setPaneHeight } = props;
  const paneRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (paneRef.current && setPaneHeight) {
      setPaneHeight(paneRef.current.offsetHeight + 30);
    }
  }, []);

  // x={{
  //   listStyleType: "circle",
  //   mx: "10px",
  //   px: "15px",
  //   li: {
  //     my: "10px",
  //     color: "primary",
  //     p: {
  //       color: "secondary",
  //     },
  //     "&::marker": {
  //       fontSize: 2,
  //       position: "relative",
  //       top: "10px",
  //     },
  //   },
  // }}
  return typeof paneContent === "string" ? (
    <div
      ref={paneRef}
      sx={{
        h2: {
          fontSize: 32,
        },
        em: {
          fontSize: [18, 22],
          lineHeight: 1.5,
        },
        pt: 4,
        td: {
          i: {
            color: "primary",
          },
        },
        i: {
          lineHeight: 1.5,
        },
        a: {
          variant: "text.link",
          fontSize: "inherit",
        },
      }}
      dangerouslySetInnerHTML={{
        __html: paneContent,
      }}
    ></div>
  ) : (
    <div
      ref={paneRef}
      sx={{
        pt: 4,
        td: {
          i: {
            color: "primary",
          },
        },
        a: {
          variant: "text.link",
          fontSize: 16,
        },
      }}
    >
      {paneContent}
    </div>
  );
};

export default AccordionPane;
